// src/hooks/termOfPayments/useDeleteAllTermOfPayments.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllTermOfPayments } from "../../api/apiTermOfPayments";
import parseError from "../../utils/parseError";

const useDeleteAllTermOfPayments = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAllTermOfPaymentsMutation, isPending } = useMutation({
        mutationFn: deleteAllTermOfPayments,
        onSuccess: (res) => {
            const message = res?.message || "Term of payments deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["termOfPayments"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete term of payments");
        },
    });

    return { deleteAllTermOfPaymentsMutation, isPending };
};

export default useDeleteAllTermOfPayments;